<template>
    <div>
        <div id="proposal-settings-template-manage-div" class="p-3">
            <div class="row">
                <div class="col-md-6 float-left mb-3">
                    <h5 class="mt-1 float-left mr-3">{{ selectedProposalContentPdf.template_name }}</h5>
                </div>
                <div class="col-md-6 float-right text-right">
                    <div class="pr-0">
                        <button id="add-proposal-template" name="add-proposal-template" @click="savePdfFromContentManage()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 text-white focus:outline-none rounded add-new-template-button">
                            Save Content
                        </button>
                    </div>
                </div>
            </div>
            <div class="card w-100">
            <div class="card-body">
                <file-pond
                    name="file"
                    ref="pond"
                    :server="server"
                    :onprocessfile="handleOnProcessFile"
                    allowRevert="false"
                    class-name="my-pond"
                    allowMultiple="false"
                    dropOnElement="true"
                    dropOnPage="true"
                    label-idle="Drop or select a pdf"
                    accepted-file-types="application/pdf"
                    labelFileTypeNotAllowed="Invalid File Type"
                    fileValidateTypeLabelExpectedTypes="Only PDFs Are Allowed."/>
            </div>
            <div v-if="url" class="card-footer">
                <button @click="removePdfFromContentManage()" class="btn btn-outline-primary rounded-full mr-2 mb-2 float-right">
                    Remove PDF
                </button>
                <iframe :src="url" class="reports-frame-style" style="height:100vh; width:100%"/>
            </div>
        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "proposal-settings-content-pdf-manage",
    props:['proposalContentPdf'],
    components: {},
    data() {
        return {
            url: (this.proposalContentPdf.pdf_url)? this.proposalContentPdf.pdf_url:'',
            selectedProposalContentPdf: this.proposalContentPdf,
            server: {
                process: (fieldName, file, metadata, load, error, progress) => {
                    const formData = new FormData();
                    formData.append('file', file, file.name);
                    formData.append('content', this.selectedProposalContentPdf.id);
                    const request = new XMLHttpRequest();
                    request.open('POST', '/api/proposal-settings/content/pdf/upload');
                    let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                    request.setRequestHeader('X-CSRF-TOKEN', token);
                    let self = this;
                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                            let data = JSON.parse(request.responseText);
                            self.selectedProposalContentPdf = data.content;
                            self.url = data.content.pdf_url;
                        } else {
                            error('oh no');
                        }
                    };
                    request.send(formData);
                }
            },
        }
    },
    mounted(){

    },
    methods: {
        handleOnProcessFile() {
            this.$refs.pond.removeFile();
        },
        savePdfFromContentManage(){
            axios.post(route('api.proposal-content.pdf.save'), {content: this.selectedProposalContentPdf, url:this.url}).then((response) => {
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }
            });
        },
        removePdfFromContentManage(){
            this.url = '';
        }
    }
};
</script>

<style>
#proposal-settings-template-manage-div {
    padding: 5px 0;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
    background-color:#fff;
    min-height: 80vh;
    border-radius:5px;
}
#proposal-settings-template-manage-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-manage-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
</style>
